import React from 'react';
import { AreaChart, Area, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer } from 'recharts';
import Card from '../../../components/common/Card';
import { format } from 'date-fns';

export default function TimelineChart({ data, isLoading }) {
  const chartData = React.useMemo(() => {
    if (!Array.isArray(data)) return [];
    
    return data.map(item => ({
      date: item.date,
      total: Number(item.total || 0),
      verified: Number(item.verified || 0)
    })).sort((a, b) => new Date(a.date) - new Date(b.date));
  }, [data]);

  if (isLoading) {
    return (
      <Card title="Email Activity Timeline">
        <div className="h-96 w-full p-4 flex items-center justify-center">
          <p className="text-ebony">Loading chart data...</p>
        </div>
      </Card>
    );
  }

  if (!chartData.length) {
    return (
      <Card title="Email Activity Timeline">
        <div className="h-96 w-full p-4 flex items-center justify-center">
          <p className="text-ebony">No data available</p>
        </div>
      </Card>
    );
  }

  return (
    <Card title="Email Activity Timeline">
      <div className="h-96 w-full p-4">
        <ResponsiveContainer>
          <AreaChart
            data={chartData}
            margin={{ top: 10, right: 30, left: 0, bottom: 0 }}
          >
            <CartesianGrid strokeDasharray="3 3" />
            <XAxis
              dataKey="date"
              tickFormatter={date => format(new Date(date), 'MMM d')}
              tick={{ fill: '#1C3F45' }}
            />
            <YAxis 
              tick={{ fill: '#1C3F45' }}
              tickFormatter={value => Math.round(value)}
              allowDecimals={false}
            />
            <Tooltip
              content={({ active, payload, label }) => {
                if (!active || !payload?.length) return null;
                return (
                  <div className="bg-white p-3 border rounded-lg shadow-md">
                    <p className="font-medium">
                      {format(new Date(label), 'MMM d, yyyy')}
                    </p>
                    <p className="text-sm text-violet">
                      Total Emails: {payload[0]?.value}
                    </p>
                    <p className="text-sm text-spring-green">
                      Verified Emails: {payload[1]?.value}
                    </p>
                  </div>
                );
              }}
            />
            <Area
              type="monotone"
              dataKey="total"
              name="Total Emails"
              stroke="#5E3258"
              fill="#5E3258"
              fillOpacity={0.2}
            />
            <Area
              type="monotone"
              dataKey="verified"
              name="Verified Emails"
              stroke="#48BB78"
              fill="#48BB78"
              fillOpacity={0.2}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    </Card>
  );
}